import { BenefitsEnums } from "models/enums";

const { BenefitType } = BenefitsEnums;

// The employee pays an amount and receives no benefit value, so the form speaks of a deduction.
const DeductionBenefitTypes: BenefitsEnums.BenefitType[] = [
  BenefitType.NetDeduction,
  BenefitType.SalarySacrifice,
  BenefitType.GrossDeduction,
  BenefitType.NetDeductionNoVat,
  BenefitType.NetDeductionInsurance,
];

// Rental compensation is a cash payment and the deductions carry no benefit value, so the valuation article does not apply.
const TypesWithoutBenefitValue: BenefitsEnums.BenefitType[] = [
  ...DeductionBenefitTypes,
  BenefitType.RentalCompensation,
];

// A debt is usually settled in one go, while the other types recur every month.
const OneTimeByDefaultBenefitTypes: BenefitsEnums.BenefitType[] = [BenefitType.NetDeductionNoVat];

export const getDefaultBenefitFrequency = (type?: number | string): BenefitsEnums.BenefitFrequency =>
  type !== undefined && OneTimeByDefaultBenefitTypes.includes(Number(type))
    ? BenefitsEnums.BenefitFrequency.Once
    : BenefitsEnums.BenefitFrequency.Monthly;

export const isDeductionBenefitType = (type?: number | string) =>
  type !== undefined && DeductionBenefitTypes.includes(Number(type));

export const hasBenefitValue = (type?: number | string) =>
  type !== undefined && !TypesWithoutBenefitValue.includes(Number(type));
